(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationActionDefinition', CommunicationActionDefinition);

    CommunicationActionDefinition.$inject = ['$resource'];

    function CommunicationActionDefinition ($resource) {
        var resourceUrl =  'api/communication-action-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryAllOrdered' : {
                url: 'api/communication-action-definitions-all-ordered/',
                method : 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
